var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "md", modalId: "modal-lv3" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base mb-5" }, [
              _vm._v(
                _vm._s(_vm.updatedPhone ? "Edit" : "Add") + " Phone Number"
              ),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-5",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("ModalContent", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "mt-5" },
                [
                  _c("ValidationProvider", {
                    attrs: {
                      name: "Phone number",
                      rules: {
                        phoneNumberLength: [
                          _vm.phone ? _vm.phone.toString().length : 0,
                        ],
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ errors }) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex flex-row gap-2" },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    staticClass: "flex-1",
                                    attrs: {
                                      title: "",
                                      type: "search",
                                      errors: _vm.phoneTouched ? errors : [],
                                      isIcon: false,
                                      inputClass: "fullwidthInput",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function () {
                                            return [
                                              _c("p", { staticClass: "mb-2" }, [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "required-icon",
                                                  },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v("Phone number "),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("MaskedPhoneInput", {
                                      attrs: {
                                        invalid: Boolean(
                                          _vm.phoneTouched && errors?.length
                                        ),
                                      },
                                      on: {
                                        touched: () => {
                                          _vm.phoneHasErrors = !!errors?.length
                                          _vm.phoneTouched = true
                                        },
                                      },
                                      model: {
                                        value: _vm.phone,
                                        callback: function ($$v) {
                                          _vm.phone = $$v
                                        },
                                        expression: "phone",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c(
                    "div",
                    { staticClass: "flex justify-end mt-2 pt-3 gap-4" },
                    [
                      _c("UIButton", {
                        attrs: {
                          buttonText: "Cancel",
                          size: "lg",
                          variant: "outline",
                          processing: _vm.processing,
                        },
                        on: { click: _vm.closeModal },
                      }),
                      !_vm.updatedPhone
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Add",
                              size: "lg",
                              variant: "black",
                              processing: _vm.processing,
                              disabled: !_vm.phone || !!_vm.errors?.length,
                            },
                            on: { click: _vm.addPhone },
                          })
                        : _vm._e(),
                      _vm.updatedPhone
                        ? _c("UIButton", {
                            attrs: {
                              buttonText: "Save",
                              size: "lg",
                              variant: "black",
                              processing: _vm.processing,
                              disabled: !!_vm.errors?.length,
                            },
                            on: { click: _vm.editPhone },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }